"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import { UiFormController } from "@/components/form/UiForm.vue";
import DateFormat from "@/framework/timeformatter";
import { Debounce } from "vue-debounce-decorator";
import TeamLogSearchForm from "./search/TeamLogSearchForm.vue";
class FormController extends UiFormController {
  constructor() {
    super(...arguments);
    this.operatorName = null;
    this.createdTime = [];
    this.eventType = null;
    this.targetName = null;
  }
}
let TeamLogs = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.selectOption = [
      {
        value: "auth_user",
        label: this.$t("teamLogs.table.event_auth_user")
      },
      {
        value: "user_delete_auto",
        label: this.$t("teamLogs.table.event_user_delete_auto")
      },
      {
        value: "vd_admin_user",
        label: this.$t("teamLogs.table.event_vd_admin_user")
      },
      {
        value: "user_delete",
        label: this.$t("teamLogs.table.event_user_delete")
      },
      {
        value: "user_add",
        label: this.$t("teamLogs.table.event_user_add")
      },
      {
        value: "user_edit_power",
        label: this.$t("teamLogs.table.event_user_edit_power")
      },
      {
        value: "auth_user_cancel",
        label: this.$t("teamLogs.table.event_auth_user_cancel")
      },
      {
        value: "vd_admin_user_cancel",
        label: this.$t("teamLogs.table.event_vd_admin_user_cancel")
      }
    ];
    this.gridController = new GridController(
      new APIDataSource("api://base.auth.pro/v1/team-operation-logs")
    );
    this.formcontroller = new FormController();
    this.pickerOptions = {
      shortcuts: [
        {
          text: this.$t("loginlogs.today"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(new Date(start.toLocaleDateString()).getTime());
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: this.$t("loginlogs.lastday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(
              new Date(start.toLocaleDateString()).getTime() - 3600 * 1e3 * 24
            );
            start.setHours(0, 0, 0, 0);
            end.setTime(new Date(end.toLocaleDateString()).getTime());
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: this.$t("loginlogs.thisweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(
              start.getTime() - (start.getDay() - 1) * 3600 * 1e3 * 24
            );
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: this.$t("loginlogs.lastsevenday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1e3 * 24 * 7);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: this.$t("loginlogs.lastweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(
              start.getTime() - (start.getDay() + 6) * 3600 * 1e3 * 24
            );
            start.setHours(0, 0, 0, 0);
            end.setTime(end.getTime() + (0 - end.getDay()) * 3600 * 1e3 * 24);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: this.$t("loginlogs.thismonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.setDate(1));
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: this.$t("loginlogs.lastthirtydays"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1e3 * 24 * 30);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: this.$t("loginlogs.lastmonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(
              new Date(start.setMonth(start.getMonth() - 1)).setDate(1)
            );
            start.setHours(0, 0, 0, 0);
            end.setTime(end.setDate(1));
            picker.$emit("pick", [start, end]);
          }
        }
      ],
      disabledDate(time) {
        return time.getTime() > new Date(
          new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1e3 - 1
        ) || time.getTime() < new Date(new Date().setMonth(new Date().getMonth() - 6));
      }
    };
    this.searchStr = "";
    this.searchSub = "";
    this.searchSelect = "";
    this.searchDate = [
      new Date(new Date().getTime() - 3600 * 1e3 * 24 * 7),
      new Date()
    ];
    this.searchStr_dates = null;
    this.searchSub_datas = null;
    this.searchDate_dates = null;
    this.searchParams = {
      search: ""
    };
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.searchByDate(this.searchDate);
    });
  }
  showRightDrawer() {
    return __async(this, null, function* () {
      yield this.clearSearch();
      const _advancedSearchForm = TeamLogSearchForm.create(this.formcontroller);
      _advancedSearchForm.$on("search", this.searchQuery);
      _advancedSearchForm.show();
    });
  }
  searchQuery(query) {
    return __async(this, null, function* () {
      this.searchParams.search = query.params;
      this.gridController.query.params = this.searchParams;
      this.gridController.query.current = 1;
      yield this.gridController.search();
    });
  }
  format_login_time(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.dateformat(DateFormat.check(time));
    }
  }
  searchByName(searchStr) {
    return __async(this, null, function* () {
      if (searchStr !== null && searchStr !== "") {
        this.searchStr_dates = `operatorName=like='${searchStr}';`;
        yield this.checkAllSearch();
        return;
      }
      if (searchStr === null || searchStr === "") {
        this.searchStr_dates = null;
        yield this.checkAllSearch();
      }
    });
  }
  searchBySub(searchSub) {
    return __async(this, null, function* () {
      if (searchSub !== null && searchSub !== "") {
        this.searchSub_datas = `targetName=like='${searchSub}';`;
        yield this.checkAllSearch();
        return;
      }
      if (searchSub === null || searchSub === "") {
        this.searchSub_datas = null;
        yield this.checkAllSearch();
      }
    });
  }
  searchByDate(searchDate) {
    return __async(this, null, function* () {
      if (searchDate !== null && searchDate.length !== 0) {
        let mintime = Date.parse(searchDate[0]);
        let maxtime = Date.parse(searchDate[1]);
        this.searchDate_dates = `createdTime=between=(${DateFormat.ToSecond(mintime)},${DateFormat.ToSecond(maxtime)});`;
        yield this.checkAllSearch();
        return;
      }
      if (searchDate === null || searchDate.length === 0) {
        this.searchDate_dates = null;
        yield this.checkAllSearch();
      }
    });
  }
  checkSelectChange() {
    return __async(this, null, function* () {
      yield this.checkAllSearch();
    });
  }
  checkAllSearch() {
    return __async(this, null, function* () {
      this.searchParams = {
        search: ""
      };
      if (this.searchDate_dates !== null) {
        this.searchParams.search += this.searchDate_dates;
      }
      if (this.searchStr_dates !== null) {
        this.searchParams.search += this.searchStr_dates;
      }
      if (this.searchSub_datas !== null) {
        this.searchParams.search += this.searchSub_datas;
      }
      if (this.searchSelect !== null && this.searchSelect !== "") {
        this.searchParams.search += `eventType==${this.searchSelect};`;
      }
      this.gridController.query.params = this.searchParams;
      yield this.gridController.search();
    });
  }
  clearSearch() {
    return __async(this, null, function* () {
      if (this.searchStr !== "" && this.searchStr !== null || this.searchDate !== null && this.searchDate.length > 0) {
        this.searchStr = "";
        this.searchDate = [];
        this.gridController.query.params = null;
        yield this.gridController.search();
      }
    });
  }
};
__decorateClass([
  Debounce(500)
], TeamLogs.prototype, "searchByName", 1);
__decorateClass([
  Debounce(500)
], TeamLogs.prototype, "searchBySub", 1);
__decorateClass([
  Debounce(500)
], TeamLogs.prototype, "searchByDate", 1);
__decorateClass([
  Debounce(500)
], TeamLogs.prototype, "checkSelectChange", 1);
TeamLogs = __decorateClass([
  Component({
    components: {
      UiGrid
    }
  })
], TeamLogs);
export {
  TeamLogs as default
};
